"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const luxon_1 = require("luxon");
const react_use_1 = require("react-use");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const PersonOutlineRounded_1 = __importDefault(require("@mui/icons-material/PersonOutlineRounded"));
const core_1 = require("companion-app-components/utils/core");
const profile_1 = require("companion-app-components/flux/profile");
const auth_1 = require("companion-app-components/flux/auth");
const Dump_1 = __importDefault(require("components/Dump"));
const RendersCount_1 = __importDefault(require("components/RendersCount"));
const subscriptionsSelectors = __importStar(require("data/subscriptions/subscriptionsSelectors"));
const subscriptionsActions = __importStar(require("data/subscriptions/subscriptionsActions"));
const styles_1 = __importDefault(require("./styles"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const General = () => {
    const { classes } = useStyles();
    const profile = (0, react_redux_1.useSelector)((state) => profile_1.profileSelectors.getProfile(state));
    const subscriptionsIsLoading = (0, react_redux_1.useSelector)((state) => subscriptionsSelectors.getIsLoading(state));
    const subscription = (0, react_redux_1.useSelector)((state) => subscriptionsSelectors.getActiveSubscription(state));
    const authSession = (0, react_redux_1.useSelector)((state) => auth_1.authSelectors.getAuthSession(state));
    const dispatch = (0, react_redux_1.useDispatch)();
    (0, react_use_1.useEffectOnce)(() => {
        if (!subscriptionsIsLoading) {
            dispatch(subscriptionsActions.getSubscriptions());
        }
    });
    const goToEditDetails = () => {
        core_1.tracker.track(core_1.tracker.events.myAccount, { location: 'profile' });
        window.open(`${(0, core_1.getEnvironmentConfig)().myaccount_url}?bearer=${authSession.accessToken}`);
    };
    const expiryDate = (subscription === null || subscription === void 0 ? void 0 : subscription.inactiveAt) || (subscription === null || subscription === void 0 ? void 0 : subscription.expireOn);
    return (<>
      <Box_1.default marginBottom={3}>
        <Typography_1.default id={'settings_general_page_header'} variant="h5" className={classes.headlineText}>
          <PersonOutlineRounded_1.default className={classes.headlineIcon}/>
          <span>General</span>
        </Typography_1.default>
      </Box_1.default>

      <RendersCount_1.default id="general-tab"/>
      <div className={classes.personalDetails}>
        <Box_1.default marginBottom={2} position="relative">
          <Dump_1.default obj={[profile, subscription]}/>
          <Typography_1.default variant="subtitle2">
            Account
          </Typography_1.default>
        </Box_1.default>

        <div className={classes.infoGroup}>
          <Typography_1.default variant="caption">Quicken ID</Typography_1.default>
          <Typography_1.default id="user-details-id" variant="body2">{profile && profile.username}</Typography_1.default>
        </div>

        <div className={classes.infoGroup}>

          <Typography_1.default variant="caption">
            {(subscription === null || subscription === void 0 ? void 0 : subscription.autoRenew) ?
            'Subscription renews on' :
            'Subscription expires on'}
          </Typography_1.default>
          <Typography_1.default variant="body2">
            {expiryDate ?
            luxon_1.DateTime.fromISO(expiryDate).toFormat('LLL dd, yyyy') :
            '-'}
          </Typography_1.default>
        </div>

        <Button_1.default color="primary" id="edit-details" onClick={goToEditDetails} style={{ position: 'relative', left: -8 }}>
          Go To My Account
        </Button_1.default>
      </div>
    </>);
};
exports.default = General;
